import React from 'react'
import { useEffect } from 'react'
import ConversionTracking from "./ConversionTracking";
import undreview from '../images/undreview.gif' 
export default function SuccessPage() {

    useEffect(() => {
        setTimeout(()=>{
            localStorage.clear();
            window.open(process.env.REACT_APP_CLOSING_URL, "_self");
        },[3000])
    }, [])
    const handleClickReview=(e)=>{
        e.preventDefault();
        localStorage.clear();
        window.open(process.env.REACT_APP_CLOSING_URL, "_self");

    }
  return (
    <div className='underreviewresults'>
         <ConversionTracking/>
        <div className='loadingimages'>
        <img src={undreview}></img>
        <p className='review-text'>Under Review!</p>
        <p className='review-message'>We're still reviewing your details and assessing your loan limit. We'll get back to you soon with an update.</p>
        <button onClick={handleClickReview}>Continue</button>
        </div>

    </div>
  )
}